












import { Component, Vue } from "vue-property-decorator";
import UnsubscribeEmployee from "@/components/employee/UnsubscribeEmployee.vue";

@Component({
  components: {
    UnsubscribeEmployee
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: "Inicio",
          to: "/home",
          disabled: false
        },
        {
          text: "Empleados",
          to: "/employees/list",
          disabled: false
        },
        {
          text: "Baja masiva",
          to: "#",
          disabled: true
        }
      ]
    };
  }
})
export default class Unsubscribe extends Vue {}
